import Vue from 'vue';
import App from './App';
import router from './router';
import CoreuiVue from '@coreui/vue';
import { iconsSet as icons } from './assets/icons/icons.js';
import store from './store/';
import { ValidationObserver, ValidationProvider, extend, localize } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import TW from 'vee-validate/dist/locale/zh_TW.json';
import VueAWN from 'vue-awesome-notifications';
import { getUrlLang } from '@/services/check';

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});
if (getUrlLang() != 'en_us') {
    localize('zh_TW', TW);
}
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.config.performance = true;
Vue.use(CoreuiVue);
let options = { position: 'top-right' };
Vue.use(VueAWN, options);
Vue.prototype.$log = console.log.bind(console);
new Vue({
    el: '#app',
    router,
    store,
    icons,
    template: '<App/>',
    components: {
        App,
    },
});
